import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UpdateConfigSettingsdata, GetConfigSettingsdata } from "../../../Service/Configsettings/ConfigsettingsService";




export const cofigsettingsdetails = createAsyncThunk("updateConfigSetting", async (data) => {
    try {
        const res = await UpdateConfigSettingsdata(data);
        return await res;
    } catch (err) {
        return err;
    }
});


export const getconfigdata = createAsyncThunk("getConfigSetting", async (data) => {
    try {
        const res = await GetConfigSettingsdata(data);
        return await res;
    } catch (err) {
        return err;
    }
});



const ConfigSettings = createSlice({
    name: "ConfigSettings",
    initialState: {
        isLoading: false,
        isError: false,
        cofigsettingsdetails: [],
        getconfigdata: [],
    },

    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(cofigsettingsdetails.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(cofigsettingsdetails.fulfilled, (state, action) => {
                state.isLoading = false;
                state.cofigsettingsdetails = action.payload;
            })
            .addCase(cofigsettingsdetails.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
            })
            .addCase(getconfigdata.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getconfigdata.fulfilled, (state, action) => {
                state.isLoading = false;
                state.getconfigdata = action.payload;
            })
            .addCase(getconfigdata.rejected, (state, action) => {
                state.isLoading = false;
                state.isError = true;
            })

    },
});

export default ConfigSettings;